import { Phone } from "lucide-react";
import { useLanguage, CONTACTS } from "../i18n";

export const StickyBar = () => {
  const { t } = useLanguage();
  return (
    <div
      data-testid="sticky-mobile-reservation-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-[#C69255]/25"
      style={{ backgroundColor: "rgba(44, 15, 26, 0.96)", backdropFilter: "blur(12px)" }}
    >
      <div className="grid grid-cols-2">
        <a
          data-testid="sticky-mobile-call-btn"
          href={`tel:${CONTACTS.phone}`}
          className="flex items-center justify-center gap-2 py-4 text-[#E9DCCF] font-meta text-[10px] uppercase tracking-[0.2em]"
        >
          <Phone size={15} strokeWidth={1.5} />
          {t.sticky.call}
        </a>
        <a
          data-testid="sticky-mobile-prenota-btn"
          href={CONTACTS.superbUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center bg-[#C69255] text-[#2C0F1A] font-meta text-[10px] uppercase tracking-[0.2em] font-medium"
        >
          {t.sticky.book}
        </a>
      </div>
    </div>
  );
};
